import { useEffect, useState } from "react";

// Métadonnées légères du thème actif, renseignées par App.js au chargement de
// /theme/init et lues par des composants isolés (ex: la fiche produit qui
// adapte sa mise en page pour le thème Chocolatier).
// `customPages` : pages créées depuis le Studio pour le thème servi
// (`[{path, template, label}]`), que le routeur public ne peut pas connaître
// à l'avance — voir pages/EnginePage.jsx. `loaded` passe à vrai à la
// première réponse de /theme/init : avant, « page introuvable » serait
// prématuré.
let _meta = { name: "", productLayout: "default", customPages: [], loaded: false };
const _subs = new Set();

export function setThemeMeta(meta) {
  _meta = { ..._meta, ...meta };
  _subs.forEach((fn) => fn(_meta));
}

export function getThemeMeta() {
  return _meta;
}

export function useThemeMeta() {
  const [meta, setMeta] = useState(_meta);
  useEffect(() => {
    _subs.add(setMeta);
    setMeta(_meta);
    return () => _subs.delete(setMeta);
  }, []);
  return meta;
}

// Vrai si le thème actif utilise la mise en page produit Chocolatier.
// On se base d'abord sur un marqueur STABLE (`product_layout`, insensible au
// renommage du thème), avec repli sur le nom pour les thèmes littéralement
// nommés "Chocolatier…". Choix produit : la fiche produit plein écran ne
// s'applique qu'à ce thème (voir ProductDetail.jsx).
export function isChocolatierTheme(meta) {
  const m = typeof meta === "string" ? { name: meta } : (meta || {});
  return m.productLayout === "chocolatier" || /chocolat/i.test(m.name || "");
}
